import styled from 'styled-components';

export const TooltipContentContainer = styled.span`
  z-index: 999;
  padding: 0;
  font-size: 10px;
  font-style: normal;
  font-weight: 400;
  letter-spacing: 1px;
  display: flex;
  align-items: center;
  text-align: center;
  gap: 15px;
`;
